import { findIndex } from "lodash";
// import sendxAPI from '../xAPI'

const templateState = {

  showGelPipetteModal: false,
  showOrientationModal: false,

  containsGel: false,
  containsBuffer: false,
  gelOrientation: 360,
  gelIncrementation: 180,
  timer: 0,
  active: false,
  open: false,
  anodeConnected: false,
  cathodeConnected: false,
  solutions: null,
  solutionAlias: null,
  volume: 0,
  showTooltipControls: false,

  pipetteId: null,
  gelId: null
};

export default (state = templateState, action) => {
  let currentGelBox;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (action.type !== "CREATE_GEL_BOX" && !action.type.includes("@redux")) {
    if (action.payload.hasOwnProperty("id")) {
      if (state.protocolSection.scene.apparatus.hasOwnProperty("gelBoxes")) {
        currentGelBox =
          state.protocolSection.scene.apparatus.gelBoxes[
            findIndex(state.protocolSection.scene.apparatus.gelBoxes, {
              id: action.payload.id,
            })
          ];
      }
    }
  }
  switch (action.type) {
    case "CREATE_GEL_BOX":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("gelBoxes")) {
        protocolSection.scene.apparatus.gelBoxes = [
          ...protocolSection.scene.apparatus.gelBoxes,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.gelBoxes = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };

    case "SET_GEL_BOX":
      //Payload = {...}
      return { ...state, ...action.payload };

    case "SET_GEL_IN_BOX":
      //Payload = {containsGel}
      currentGelBox.containsGel = action.payload.containsGel;
      currentGelBox.gelId = action.payload.gelId;

      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;
      return {
        ...state,
        ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
      };


    case "SHOW_TOOL_TIP_CONTROLS":
      //Payload = {containsGel}
      currentGelBox.showTooltipControls = action.payload.showTooltipControls;

      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;
      return {
        ...state,
        ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
      };

    case "EJECT_GEL_FROM_GEL_BOX":
       //Payload = {containsGel}
       currentGelBox.containsGel = false;
       currentGelBox.gelId = null;

       protocolSection.scene.apparatus.gelBoxes[
         findIndex(protocolSection.scene.apparatus.gelBoxes, {
           id: action.payload.id,
         })
       ] = currentGelBox;
       return {
         ...state,
         ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
       };


    case "SET_BUFFER_IN_BOX":
      //Payload = {containsBuffer}
      currentGelBox.containsBuffer = action.payload.containsBuffer;

      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;
      return {
        ...state,
        ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
      };

    case "SET_SOLUTION_IN_GEL_BOX":
      //Payload = {solutions, solutionAlias, volume}
      currentGelBox.solutions = action.payload.solutions;
      currentGelBox.solutionAlias = action.payload.solutionAlias;
      currentGelBox.volume += action.payload.volume;

      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;
      return {
        ...state,
        ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
      };

    case "SET_GEL_ORIENTATION":
      //Payload = {gelOrientation}
      currentGelBox.gelOrientation = action.payload.gelOrientation;

      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;
      return {
        ...state,
        ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
      };

    case "DEC_GEL_ORIENTATION":
      //Decreases orientation by increment
      if (currentGelBox.gelOrientation - currentGelBox.gelIncrementation >= 0) {
        currentGelBox.gelOrientation -= currentGelBox.gelIncrementation;

        //Lodash merge current gelBox into gelBoxes array
        protocolSection.scene.apparatus.gelBoxes[
          findIndex(protocolSection.scene.apparatus.gelBoxes, {
            id: action.payload.id,
          })
        ] = currentGelBox;
        return {
          ...state,
          ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
        };
      } else if (
        currentGelBox.gelOrientation - currentGelBox.gelIncrementation <
        0
      ) {
        currentGelBox.gelOrientation = 360 - currentGelBox.gelIncrementation;

        //Lodash merge current gelBox into gelBoxes array
        protocolSection.scene.apparatus.gelBoxes[
          findIndex(protocolSection.scene.apparatus.gelBoxes, {
            id: action.payload.id,
          })
        ] = currentGelBox;
        return {
          ...state,
          ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
        };
      } else {
        return state;
      }

    case "INC_GEL_ORIENTATION":
      //Increases orientation by increment
      if (
        currentGelBox.gelOrientation + currentGelBox.gelIncrementation <=
        360
      ) {
        currentGelBox.gelOrientation += currentGelBox.gelIncrementation;

        //Lodash merge current gelBox into gelBoxes array
        protocolSection.scene.apparatus.gelBoxes[
          findIndex(protocolSection.scene.apparatus.gelBoxes, {
            id: action.payload.id,
          })
        ] = currentGelBox;
        return {
          ...state,
          ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
        };
      } else if (
        currentGelBox.gelOrientation + currentGelBox.gelIncrementation >
        360
      ) {
        currentGelBox.gelOrientation = 0 + currentGelBox.gelIncrementation;

        //Lodash merge current gelBox into gelBoxes array
        protocolSection.scene.apparatus.gelBoxes[
          findIndex(protocolSection.scene.apparatus.gelBoxes, {
            id: action.payload.id,
          })
        ] = currentGelBox;
        return {
          ...state,
          ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
        };
      } else {
        return state;
      }

    case "SET_GEL_BOX_TIMER":
      //Payload = {timer}
      currentGelBox.timer = action.payload.timer;

      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;
      return {
        ...state,
        ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
      };

    case "SET_GEL_BOX_ACTIVE":
      //Payload = {active}
      currentGelBox.active = action.payload.active;

      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;
      return {
        ...state,
        ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
      };

    case "SET_GEL_BOX_OPEN":
      //Payload = {open}
      currentGelBox.open = action.payload.open;

      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;
      return {
        ...state,
        ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
      };

    case "SET_GEL_BOX_ANODE_CONNECTED":
      //Payload = {anodeConnected}
      currentGelBox.anodeConnected = action.payload.anodeConnected;

      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;
      return {
        ...state,
        ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
      };

    case "SET_GEL_BOX_CATHODE_CONNECTED":
      //Payload = {cathodeConnected}
      currentGelBox.cathodeConnected = action.payload.cathodeConnected;

      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;
      return {
        ...state,
        ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
      };


    case "GELBOX_TOGGLE_ORIENTATION_MODAL":

      currentGelBox.showOrientationModal =
        action.payload.showOrientationModal;

      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;
      return {
        ...state,
        ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
      };

    case "GELBOX_TOGGLE_GELPIPETTE_MODAL":
      currentGelBox.showGelPipetteModal =
        action.payload.showGelPipetteModal;

      if(action.payload.showGelPipetteModal){
        currentGelBox.pipetteId =
          action.payload.pipetteId;
      } else {
        currentGelBox.pipetteId =
          null;
      }

      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;
      return {
        ...state,
        ...{ gelBoxes: protocolSection.scene.apparatus.gelBoxes },
      };

    case "GELBOX_TOGGLE_TOOLTIP_CONTROLS":
      currentGelBox.showTooltipControls =
        action.payload.showTooltipControls;
      protocolSection.scene.apparatus.gelBoxes[
        findIndex(protocolSection.scene.apparatus.gelBoxes, {
          id: action.payload.id,
        })
      ] = currentGelBox;

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };

    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null) {

        protocolSection.scene.apparatus.gelBox = action.payload.lastState.scene.apparatus.gelBox

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      } else {
        return state;
      }

    default:
      return state;
  }
};
